module.exports = __webpack_public_path__ + "static/media/postcardRetro5.becc36c7.jpg";